import { BlocksIconDealer } from 'blocks-nextjs/blocks-web-components/components/icon/icons/dealer';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconDealer = createComponent({ react: React, tagName: 'cat-icon-dealer', elementClass: BlocksIconDealer });
